import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PlatformHttpService } from '../../../services/platform-http.service';
import { HttpParams } from '@angular/common/http';
import {
  ProductionActivityTypeResponse,
  CreateProductionActivityTypeRequest,
  UpdateProductionActivityTypeRequest,
  ProductionActivityTypeListResponse,
  ProductionActivityTypeFilters,
  ProductionActivityTypeDto
} from '../models';

@Injectable({
  providedIn: 'root'
})
export class ProductionActivityTypeService {
  private platformHttp = inject(PlatformHttpService);

  getProductionActivityTypes(filters: ProductionActivityTypeFilters = {}): Observable<ProductionActivityTypeListResponse> {
    let params = new HttpParams();
    
    if (filters.search) {
      params = params.set('q', filters.search);
    }
    if (filters.page !== undefined) {
      params = params.set('page', filters.page.toString());
    }
    if (filters.size) {
      params = params.set('size', filters.size.toString());
    }

    return this.platformHttp.get('/production-activity-type/basic/paginated', params) as Observable<ProductionActivityTypeListResponse>;
  }

  getAllActivityTypes(): Observable<ProductionActivityTypeDto[]> {
    return this.platformHttp.get('/production-activity-type/all') as Observable<ProductionActivityTypeDto[]>;
  }

  getProductionActivityType(id: number): Observable<ProductionActivityTypeResponse> {
    return this.platformHttp.get(`/production-activity-type/${id}`) as Observable<ProductionActivityTypeResponse>;
  }

  createProductionActivityType(request: CreateProductionActivityTypeRequest): Observable<void> {
    return this.platformHttp.post('/production-activity-type', request) as Observable<void>;
  }

  updateProductionActivityType(request: UpdateProductionActivityTypeRequest): Observable<void> {
    return this.platformHttp.put(`/production-activity-type/${request.id}`, request) as Observable<void>;
  }

  deleteProductionActivityType(id: number): Observable<void> {
    return this.platformHttp.delete(`/production-activity-type/${id}`) as Observable<void>;
  }
}
